import { AllHtmlEntities } from 'html-entities';

const entities = new AllHtmlEntities();

// Identical decoding during SSR and hydration; no browser-only DOM dependency.
const decodeHtmlEntities = (text) => entities.decode(text || '');

export default decodeHtmlEntities;
